import { useEffect } from 'react';
import { useSearchModal } from '@backstage/plugin-search';

// This component must be rendered inside a <SearchModalProvider> tree.
// If placed outside the provider, useSearchModal() returns isolated state
// and pressing the shortcut will not open the sidebar modal.

export const GlobalSearchShortcut = (): null => {
  const { setOpen } = useSearchModal();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      // Reject shift/alt combos to avoid clobbering ⌘⇧K / Ctrl+Alt+K
      // (browser devtools shortcuts and user-defined OS bindings).
      const isShortcut =
        (e.metaKey || e.ctrlKey) &&
        !e.shiftKey &&
        !e.altKey &&
        (e.key === 'k' || e.key === 'K');
      if (!isShortcut) return;
      e.preventDefault();
      setOpen(true);
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
    // setOpen is a stable dispatch ref — this effect runs effectively once.
    // Using setOpen(true) rather than toggleModal so repeated presses while
    // the modal is already open are idempotent.
  }, [setOpen]);

  return null;
};
